/**
 * Mirrors inventory-manager-backend:
 * - roundMoney in orders/utils/order-paid-pricing.ts
 * - sapCondValueFromPurchasePrice in orders/services/sales-order.util.ts
 *
 * Do not invent a different VAT formula. Keep in sync via sapCondValue.test.js.
 */

export function roundMoney(value) {
  return Math.round((Number(value) || 0) * 100) / 100
}

/**
 * SAP COND_VALUE (TP) from VAT-inclusive purchase price (TP + VAT) and product VAT%.
 *   COND_VALUE = (PurchasePrice × 100) / (100 + VAT%)
 * Rounded to 2 decimal places. Null/missing VAT leaves the purchase price unchanged.
 * Zero VAT is a no-op.
 *
 * @param {number} purchasePrice VAT-inclusive unit price
 * @param {number|string|null|undefined} vatPercent
 * @returns {number}
 */
export function sapCondValueFromPurchasePrice(purchasePrice, vatPercent) {
  const price = Number(purchasePrice)
  if (!Number.isFinite(price) || price < 0) {
    throw new Error(
      'Purchase price for SAP sales order must be a non-negative number',
    )
  }

  if (vatPercent === null || vatPercent === undefined || vatPercent === '') {
    return price
  }

  const vat = Number(vatPercent)
  if (!Number.isFinite(vat) || vat < 0) {
    return price
  }
  if (vat === 0) {
    return price
  }

  return roundMoney((price * 100) / (100 + vat))
}

/**
 * True when VAT% is not configured. Zero is configured and valid.
 * Mirrors backend isProductVatMissing.
 */
export function isProductVatMissing(vat) {
  if (vat === null || vat === undefined || vat === '') return true
  const n = Number(vat)
  return !Number.isFinite(n)
}

export function normalizeProductSource(source) {
  return String(source || '')
    .trim()
    .toLowerCase()
}

/** Shwapno (or unknown/empty) requires VAT; external does not. */
export function productRequiresVat(source) {
  return normalizeProductSource(source) !== 'external'
}
